<template lang="html">
    <div>
        <div v-if="ota">
            <div class="bg-blue-pale p-2 fs-small">
                Please note that you need to have active products on GYG in order to connect with Pluralo. <a class="darkest underlined" :href="otaLink" target="_blank">Sign up with GetYourGuide</a> if you haven't already.
            </div>

            <list class="mt-4" :header="productListHeader" :body="productListBody" :rows="products" ></list>
        </div>
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import List from '@/tools/list/baseList'

export default {
    props: {
        ota:{
            type: Object
        }
    },
    created() {
        this.initProducts();
    },
    computed: {
        ...mapGetters([
            'getProducts',
            'getProductsLabels',
        ]),
        otaLink() {
            return this.ota.integration.otaLink;
        },
        products() {
            return this.getProducts;
        },
        productListHeader() {
            return {
                selection: {
                    active: false,
                    event: (event) => {}
                },
                list: {
                    id: 'ID',
                    name: 'Name',
                    code: 'Code',
                    category: 'Category',
                },
            };
        },
        productListBody() {
            return {
                selection: {
                    active: false,
                    event: (event) => {}
                },
                customCells: {
                    id: this.formatId,
                    name: this.formatName,
                    category: this.formatCategory,
                    active: this.formatActive
                },
                customRowEvent: null,
            }
        },
    },
    methods: {
        ...mapActions([
            'initProducts'
        ]),
        formatId(item) {
            return item.externalBookingSystemCode;
        },
        formatName(item) {
            return '<div class="bold">' + item.name + '</div>';
        },
        formatCategory(item) {
            return (item.categoryList.length > 0) ? item.categoryList.map(i => i.name).join(', ') : '-';
        },
        formatActive(item) {
            return (item.active) ? 'Yes' : 'No';
        },
    },
    components: {
        List
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// otaIntegration.vue?c2f409ae